(() => {
  const HIGHLIGHTS = new Set(['product highlights', 'product features']);
  const PRODUCT_SPECS = new Set([
    'product specification',
    'product specifications',
    'product specification & accessories',
    'product specifications & accessories',
    'product specification and accessories',
    'product specifications and accessories'
  ]);

  const cleanText = (value = '') =>
    value
      .replace(/[🤖📦]/gu, '')
      .replace(/\s+/g, ' ')
      .trim();

  const keyText = (value = '') => cleanText(value).toLowerCase();

  function replaceWithH4(node, label) {
    if (!node || (node.tagName === 'H4' && node.textContent.trim() === label && !node.className)) return node;
    const replacement = document.createElement('h4');
    replacement.textContent = label;
    if (node.id) replacement.id = node.id;
    node.replaceWith(replacement);
    return replacement;
  }

  function standardizeProductDescription() {
    const main = document.querySelector('main[data-template*="product"]');
    if (!main) return;

    const headings = [...main.querySelectorAll('.rte h1, .rte h2, .rte h3, .rte h4, .rte h5, .rte h6')];
    if (!headings.length) return;

    headings.forEach((heading) => {
      if (HIGHLIGHTS.has(keyText(heading.textContent))) {
        replaceWithH4(heading, '🤖 Product Highlights');
      }
    });

    const current = [...main.querySelectorAll('.rte h1, .rte h2, .rte h3, .rte h4, .rte h5, .rte h6')];
    const hasProductSpecs = current.some((heading) => PRODUCT_SPECS.has(keyText(heading.textContent)));

    current.forEach((heading) => {
      if (PRODUCT_SPECS.has(keyText(heading.textContent))) {
        replaceWithH4(heading, '📦 Product Specifications & Accessories');
      }
    });

    if (!hasProductSpecs) {
      const refreshed = [...main.querySelectorAll('.rte h1, .rte h2, .rte h3, .rte h4, .rte h5, .rte h6')];
      const weapons = refreshed.find((heading) => {
        const key = keyText(heading.textContent);
        return key === 'weapons & accessories' || key === 'weapons and accessories';
      });
      const bareSpecs = refreshed.find((heading) => keyText(heading.textContent) === 'specifications');

      if (weapons) {
        replaceWithH4(weapons, '📦 Product Specifications & Accessories');
      } else if (bareSpecs) {
        replaceWithH4(bareSpecs, '📦 Product Specifications & Accessories');
      }
    }
  }

  function primaryProductScope() {
    const main = document.querySelector('main[data-template*="product"]');
    if (!main) return null;
    const price = main.querySelector('product-price[data-product-id], product-price');
    return price?.closest('.product-details') || price?.parentElement?.parentElement || main;
  }

  function preorderTextElement(scope) {
    if (!scope) return null;
    const candidates = scope.querySelectorAll('span, small, label, strong, div');
    for (const el of candidates) {
      if (el.childElementCount > 0) continue;
      const key = keyText(el.textContent).replace(/[\s-]/g, '');
      if (key !== 'preorder') continue;
      const rect = el.getBoundingClientRect();
      if (rect.width > 0 && rect.width <= 180 && rect.height > 0 && rect.height <= 70) return el;
    }
    return null;
  }

  function stylePreorderBadge() {
    const scope = primaryProductScope();
    const badge = preorderTextElement(scope);
    if (!badge) return false;
    badge.textContent = 'PRE-ORDER';
    badge.classList.add('mechatoy-preorder-badge');
    return true;
  }

  function productLooksLikePreorder() {
    const main = document.querySelector('main[data-template*="product"]');
    if (!main) return false;
    const title = cleanText(main.querySelector('h1')?.textContent || '');
    if (/^pre[-\s]?order\b/i.test(title)) return true;
    return Boolean(preorderTextElement(primaryProductScope()));
  }

  function ensureProductShippingNotice() {
    const main = document.querySelector('main[data-template*="product"]');
    if (!main || !productLooksLikePreorder()) return;
    if (main.querySelector('.mechatoy-preorder-shipping-note')) return;

    const scope = primaryProductScope() || main;
    const buyButtons = scope.querySelector('.buy-buttons-block, product-form-component');
    if (!buyButtons) return;

    const note = document.createElement('div');
    note.className = 'mechatoy-preorder-shipping-note';
    note.innerHTML = '<strong>Pre-order shipping:</strong> Shipping is not charged at checkout. Actual shipping will be calculated and collected separately once the item arrives and is ready to dispatch.';
    buyButtons.parentNode.insertBefore(note, buyButtons);
  }

  function cartLooksLikePreorder(root) {
    if (!root) return false;
    const titles = [...root.querySelectorAll('.cart-items__title')];
    if (titles.some((el) => /^pre[-\s]?order\b/i.test(cleanText(el.textContent)))) return true;

    const planText = [...root.querySelectorAll('.cart-items__variants-wrapper p')]
      .map((el) => cleanText(el.textContent).toLowerCase())
      .join(' ');
    return /pre[-\s]?order|deposit/.test(planText);
  }

  function updateCartNotice(root, summarySelector) {
    if (!root) return;
    const summary = root.querySelector(summarySelector);
    if (!summary) return;

    let note = summary.querySelector('.mechatoy-cart-preorder-note');
    if (!cartLooksLikePreorder(root)) {
      note?.remove();
      return;
    }

    if (!note) {
      note = document.createElement('div');
      note.className = 'mechatoy-cart-preorder-note';
      note.innerHTML = '<strong>Pre-order shipping:</strong> Shipping is not charged at checkout and will be billed separately when the item is ready to ship.';
      summary.prepend(note);
    }
  }

  function standardize() {
    standardizeProductDescription();
    stylePreorderBadge();
    ensureProductShippingNotice();
    updateCartNotice(document.querySelector('#cart-drawer'), '.cart-drawer__summary');
    updateCartNotice(document.querySelector('.cart-page'), '.cart-page__summary');
  }

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      standardize();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', standardize, { once: true });
  } else {
    standardize();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
